import { Body, Container, Head, Html, Section } from '@react-email/components';
import Footer from 'emails/EmailLayout/Footer';

import React from 'react';

import BrandLogo from './BrandLogo';
import BeSeenLogo from './BeSeenLogo';

const EmailLayout = ({ children }) => {
    return (

        <Html>
            <Head>
                <title>Be:Seen</title>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
                    rel="stylesheet"
                />
                <link
                    href="https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap"
                    rel="stylesheet"
                />
            </Head>
            <Body style={{ backgroundColor: '#f5f5f5', margin: 0, padding: 0 }}>
                <Container
                    style={{
                        maxWidth: '100%',
                        width: '100%',
                        margin: '40px auto',
                        backgroundColor: '#F5F1ED',
                        borderRadius: '16px',
                        padding: '20px 40px',
                    }}
                >
                    {/* Branding Section */}
                    <Section>
                        <BeSeenLogo></BeSeenLogo>
                    </Section>

                    {/* Main Email Content */}
                    <Section
                        style={{
                            backgroundColor: '#fff',
                            padding: '40px',
                            borderRadius: '16px',
                            boxShadow: '0px 10px 30px rgba(62, 62, 74, 0.12)',
                            width: '75%'
                        }}
                    >
                        {children}
                    </Section>

                    {/* Footer */}
                    <Section style={{ marginTop: '20px', textAlign: 'center', fontSize: '12px', color: '#3E3E4A' }}>
                        <Footer />
                    </Section>
                </Container>
            </Body>
        </Html>
    );
};

export default EmailLayout;
